/**
 * Aperture (landing) — re-export del componente compartido en
 * src/components/arku/aperture-logo.tsx para mantener una sola fuente
 * de verdad del símbolo de marca.
 */
export { ApertureLogo } from '@/components/arku/aperture-logo';
